module.exports = __webpack_public_path__ + "img/xxm.bc14ed98.svg";